import React from "react";
// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const Five9Header = () => {
  const headCells = [
    { id: "Date / Time", numeric: false, label: "Date / Time" },
    { id: "Campaign", numeric: false, label: "Campaign" },
    { id: "Campaign Type", numeric: false, label: "Campaign Type" },
    { id: "Agent", numeric: false, label: "Agent" },
    { id: "Disposition", numeric: false, label: "Disposition" },
    { id: "Call Time", numeric: false, label: "Call Time" },
    { id: "IVR Time", numeric: false, label: "IVR Time" },
    { id: "Queue Waiting Time", numeric: false, label: "Queue Waiting Time" },
    { id: "Call Hold Time", numeric: false, label: "Call Hold Time" },
    { id: "IVR Path", numeric: false, label: "IVR Path" },
    { id: "Ani", numeric: true, label: "Ani"},
    { id: "Dnis", numeric: true, label: "Dnis"},
    { id: "Recording", numeric: false, label: "Recording" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default Five9Header;
